import { Component, OnInit, ElementRef } from '@angular/core';
import { UserModel } from 'src/app/models/userModel';
import { AuthService } from 'src/app/services/auth.service';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
  constructor(private authService: AuthService) {}
  clicked: boolean = false;

  isontalepgoster = false;
  istalepgoster = false;
  user: UserModel;
  Clicked() {
    this.clicked = true;
  }
  ngOnInit() {
    this.isontalepgoster = environment.isontalepgoster;
    this.istalepgoster = environment.istalepgoster;

    this.authService.user.subscribe((x) => (this.user = x));
  }

  logout() {
    this.authService.logout();
  }
}
